import { render } from "./FeaturesPage.vue?vue&type=template&id=69955b62&scoped=true"
import script from "./FeaturesPage.vue?vue&type=script&lang=js"
export * from "./FeaturesPage.vue?vue&type=script&lang=js"

import "./FeaturesPage.vue?vue&type=style&index=0&id=69955b62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69955b62"]])

export default __exports__